import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import HomeLayout from 'src/layouts/home';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import { paths } from '../paths';

// ----------------------------------------------------------------------

// Trang chu
const TrangChu = lazy(() => import('src/pages/home/trang-chu'));
// Bao cao
const BaoCaoMuonTra = lazy(() => import('src/pages/home/bao-cao/muon-tra'));
const BaoCaoBanDoc = lazy(() => import('src/pages/home/bao-cao/ban-doc'));
const BaoCaoAnPham = lazy(() => import('src/pages/home/bao-cao/an-pham'));
//
const TrangDanhSachLopHoc = lazy(() => import('src/pages/home/lop-hoc/danh-sach'));
const TrangNienKhoaLopHoc = lazy(() => import('src/pages/home/lop-hoc/nien-khoa'));
// An pham
const TrangDanhSachAnPham = lazy(() => import('src/pages/home/an-pham/danh-sach'));
const TrangNhaXuatBanAnPham = lazy(() => import('src/pages/home/an-pham/nha-xuat-ban'));
const TrangDanhMucAnPham = lazy(() => import('src/pages/home/an-pham/danh-muc'));
const TrangLinhVucAnPham = lazy(() => import('src/pages/home/an-pham/linh-vuc'));
const TrangNgonNguAnPham = lazy(() => import('src/pages/home/an-pham/ngon-ngu'));
const TrangTinhTrangAnPham = lazy(() => import('src/pages/home/an-pham/tinh-trang'));
const TrangDongGoptailieuAnPham = lazy(() => import('src/pages/home/an-pham/dong-gop'));
const TrangDanhSachDongGopAnPham = lazy(() => import('src/pages/home/an-pham/danh-sach-dong-gop'));
const TrangTraCuuAnPham = lazy(() => import('src/pages/home/an-pham/tra-cuu-an-pham'));
// Ban doc
const TrangDanhSachBanDoc = lazy(() => import('src/pages/home/ban-doc/danh-sach'));
const TrangNhomBanDoc = lazy(() => import('src/pages/home/ban-doc/nhom'));
const TrangDienDanBanDoc = lazy(() => import('src/pages/home/ban-doc/dien-dan'));
const TrangChiTietDienDanBanDoc = lazy(() => import('src/pages/home/ban-doc/chi-tiet-dien-dan'));
//
const TrangDanhSachMuonTra = lazy(() => import('src/pages/home/muon-tra/danh-sach'));
const TrangDanhSachQuaHan = lazy(() => import('src/pages/home/muon-tra/qua-han'));
const TrangDanhSachPhieuPhat = lazy(() => import('src/pages/home/muon-tra/phieu-phat'));
// Kho ke
const TrangKhoKe = lazy(() => import('src/pages/home/kho-ke/danh-sach-ke-hang/danh-sach'));
const TrangViTriLuuTru = lazy(() => import('src/pages/home/kho-ke/vi-tri-luu-tru/danh-sach'));
// Phi phat
const TrangDanhSachPhiPhat = lazy(() => import('src/pages/home/phi-phat/danh-sach'));
const TrangDanhSachChiTietPhat = lazy(
  () => import('src/pages/home/phi-phat/danh-sach-chi-tiet-phat')
);
// Yeu cau bo sung
const TrangDanhSachYeuCauBoSung = lazy(() => import('src/pages/home/yeu-cau-bo-sung/danh-sach'));
// Mat sach
const TrangDanhSachMatSach = lazy(() => import('src/pages/home/mat-sach/danh-sach'));
// Phi mo the
const TrangPhiMoThe = lazy(() => import('src/pages/home/phi-mo-the/danh-sach'));
// Duyet mo the
const TrangDkMoThe = lazy(() => import('src/pages/home/dk-mo-the/danh-sach'));
// Đăng ký mượn trước
const TrangDkMuonTruoc = lazy(() => import('src/pages/home/dk-muon-truoc/danh-sach'));
// Quyen han
const TrangDanhSachChucNang = lazy(() => import('src/pages/home/quyen-han/danh-sach'));
const TrangDanhSachCacQuyen = lazy(() => import('src/pages/home/quyen-han/cac-quyen'));
// Nguoi dung
const TrangDanhSachNguoiDung = lazy(() => import('src/pages/home/nguoi-dung/danh-sach'));
const TrangDanhSachTaiKhoan = lazy(() => import('src/pages/home/nguoi-dung/danh-sach-tai-khoan'));
// Cai dat
const TrangCaiDat = lazy(() => import('src/pages/home/cai-dat/cai-dat'));
// Truong hoc
const TrangTruongHoc = lazy(() => import('src/pages/home/truong-hoc/truong-hoc'));
// ----------------------------------------------------------------------

export const homeRoutes = [
  {
    path: 'trang-chu',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <TrangChu />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
  },

  {
    path: 'bao-cao',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <BaoCaoMuonTra />, index: true },
      { path: 'bao-cao-muon-tra', element: <BaoCaoMuonTra /> },
      { path: 'bao-cao-ban-doc', element: <BaoCaoBanDoc /> },
      { path: 'bao-cao-an-pham', element: <BaoCaoAnPham /> },
    ],
  },
  {
    path: 'danh-cho-ban-doc',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TrangTraCuuAnPham />, index: true },
      { path: paths.danh_cho_ban_doc.tra_cuu, element: <TrangTraCuuAnPham /> },
      { path: paths.danh_cho_ban_doc.dien_dan, element: <TrangDienDanBanDoc /> },
      { path: paths.danh_cho_ban_doc.chi_tiet_dien_dan(':id'), element: <TrangChiTietDienDanBanDoc /> },
      {
        path: paths.danh_cho_ban_doc.dong_gop_an_pham.danh_sach,
        element: <TrangDanhSachDongGopAnPham />,
      },
      { path: paths.danh_cho_ban_doc.dong_gop_an_pham.tao, element: <TrangDongGoptailieuAnPham /> },
    ],
  },
  {
    path: 'lop-hoc',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TrangDanhSachLopHoc />, index: true },
      { path: 'danh-sach-lop-hoc', element: <TrangDanhSachLopHoc /> },
      { path: 'nien-khoa-lop-hoc', element: <TrangNienKhoaLopHoc /> },
      // { path: 'chuyen-nganh-lop-hoc', element: <TrangChuyenNganhLopHoc /> },
    ],
  },
  {
    path: 'an-pham',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TrangDanhSachAnPham />, index: true },
      { path: 'danh-sach-an-pham', element: <TrangDanhSachAnPham /> },
      { path: 'nha-xuat-ban-an-pham', element: <TrangNhaXuatBanAnPham /> },
      { path: 'danh-muc-an-pham', element: <TrangDanhMucAnPham /> },
      { path: 'linh-vuc-an-pham', element: <TrangLinhVucAnPham /> },
      { path: 'ngon-ngu-an-pham', element: <TrangNgonNguAnPham /> },
      { path: 'tinh-trang-an-pham', element: <TrangTinhTrangAnPham /> },
    ],
  },
  {
    path: 'ban-doc',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TrangDanhSachBanDoc />, index: true },
      { path: 'danh-sach-ban-doc', element: <TrangDanhSachBanDoc /> },
      { path: 'nhom-ban-doc', element: <TrangNhomBanDoc /> },
    ],
  },

  {
    path: 'muon-tra',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TrangDanhSachMuonTra />, index: true },
      { path: 'danh-sach-muon-tra', element: <TrangDanhSachMuonTra /> },
      { path: 'danh-sach-qua-han', element: <TrangDanhSachQuaHan /> },
      { path: 'danh-sach-phieu-phat', element: <TrangDanhSachPhieuPhat /> },
    ],
  },
  {
    path: 'kho-ke',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TrangKhoKe />, index: true },
      { path: 'danh-sach-ke-hang', element: <TrangKhoKe /> },
      { path: 'vi-tri-luu-tru', element: <TrangViTriLuuTru /> },
      // { path: 'danh-sach-cam-muon', element: <TrangDanhSachCamMuon /> },
    ],
  },
  {
    path: 'phi-phat',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TrangDanhSachPhiPhat />, index: true },
      { path: 'danh-sach-phi-phat', element: <TrangDanhSachPhiPhat /> },
      { path: 'chi-tiet-phat', element: <TrangDanhSachChiTietPhat /> },
    ],
  },
  {
    path: 'dk-muon-truoc',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TrangDkMuonTruoc />, index: true },
      { path: 'danh-sach-dk-muon-truoc', element: <TrangDkMuonTruoc /> },
    ],
  },
  {
    path: 'yeu-cau',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TrangDanhSachYeuCauBoSung />, index: true },
      { path: 'danh-sach-yeu-cau', element: <TrangDanhSachYeuCauBoSung /> },
    ],
  },
  {
    path: 'mat-sach',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TrangDanhSachMatSach />, index: true },
      { path: 'danh-sach-mat-sach', element: <TrangDanhSachMatSach /> },
    ],
  },
  {
    path: 'phi-mo-the',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TrangPhiMoThe />, index: true },
      { path: 'danh-sach-phi-mo-the', element: <TrangPhiMoThe /> },
    ],
  },
  {
    path: 'dang-ky-mo-the',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TrangDkMoThe />, index: true },
      { path: 'danh-sach-dang-ky-mo-the', element: <TrangDkMoThe /> },
    ],
  },
  {
    path: 'quyen-han',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TrangDanhSachCacQuyen />, index: true },
      { path: 'danh-sach-cac-quyen', element: <TrangDanhSachCacQuyen /> },
      { path: 'danh-sach-chuc-nang', element: <TrangDanhSachChucNang /> },
    ],
  },
  {
    path: 'nguoi-dung',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
    children: [
      { element: <TrangDanhSachNguoiDung />, index: true },
      { path: 'danh-sach-nguoi-dung', element: <TrangDanhSachNguoiDung /> },
      { path: 'danh-sach-tai-khoan', element: <TrangDanhSachTaiKhoan /> },
    ],
  },
  {
    path: 'truong-hoc',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <TrangTruongHoc />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
  },
  {
    path: 'cai-dat',
    element: (
      <AuthGuard>
        <HomeLayout>
          <Suspense fallback={<LoadingScreen />}>
            <TrangCaiDat />
          </Suspense>
        </HomeLayout>
      </AuthGuard>
    ),
  },
];
